/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlEntityTechResultData } from './ControlEntityTechResultData';
import {
    ControlEntityTechResultDataFromJSON,
    ControlEntityTechResultDataFromJSONTyped,
    ControlEntityTechResultDataToJSON,
} from './ControlEntityTechResultData';

/**
 * 
 * @export
 * @interface ControlEntityTechResult
 */
export interface ControlEntityTechResult {
    /**
     * 
     * @type {string}
     * @memberof ControlEntityTechResult
     */
    entity_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityTechResult
     */
    entity_domain?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityTechResult
     */
    entity_name?: string;
    /**
     * 
     * @type {ControlEntityTechResultData}
     * @memberof ControlEntityTechResult
     */
    data?: ControlEntityTechResultData;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityTechResult
     */
    asset?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityTechResult
     */
    source_asset?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityTechResult
     */
    port?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityTechResult
     */
    tech_name?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlEntityTechResult
     */
    cves?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ControlEntityTechResult
     */
    shared?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityTechResult
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityTechResult
     */
    updated?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityTechResult
     */
    version?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlEntityTechResult
     */
    category?: Array<string>;
}

/**
 * Check if a given object implements the ControlEntityTechResult interface.
 */
export function instanceOfControlEntityTechResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlEntityTechResultFromJSON(json: any): ControlEntityTechResult {
    return ControlEntityTechResultFromJSONTyped(json, false);
}

export function ControlEntityTechResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEntityTechResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entity_id': !exists(json, 'entity_id') ? undefined : json['entity_id'],
        'entity_domain': !exists(json, 'entity_domain') ? undefined : json['entity_domain'],
        'entity_name': !exists(json, 'entity_name') ? undefined : json['entity_name'],
        'data': !exists(json, 'data') ? undefined : ControlEntityTechResultDataFromJSON(json['data']),
        'asset': !exists(json, 'asset') ? undefined : json['asset'],
        'source_asset': !exists(json, 'source_asset') ? undefined : json['source_asset'],
        'port': !exists(json, 'port') ? undefined : json['port'],
        'tech_name': !exists(json, 'tech_name') ? undefined : json['tech_name'],
        'cves': !exists(json, 'cves') ? undefined : json['cves'],
        'shared': !exists(json, 'shared') ? undefined : json['shared'],
        'created': !exists(json, 'created') ? undefined : json['created'],
        'updated': !exists(json, 'updated') ? undefined : json['updated'],
        'version': !exists(json, 'version') ? undefined : json['version'],
        'category': !exists(json, 'category') ? undefined : json['category'],
    };
}

export function ControlEntityTechResultToJSON(value?: ControlEntityTechResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entity_id': value.entity_id,
        'entity_domain': value.entity_domain,
        'entity_name': value.entity_name,
        'data': ControlEntityTechResultDataToJSON(value.data),
        'asset': value.asset,
        'source_asset': value.source_asset,
        'port': value.port,
        'tech_name': value.tech_name,
        'cves': value.cves,
        'shared': value.shared,
        'created': value.created,
        'updated': value.updated,
        'version': value.version,
        'category': value.category,
    };
}

